import React, { useEffect, useState } from "react";
import useBooleanState from "@clave/use-boolean-state";
import { Checkbox } from "../components/Checkbox";
import events from "../events";
import usersApiClient from "../login-register/UsersApiClient";
import Modal from "./Modal";
import styles from "./SaveSearchModal.module.scss";
export function SaveSearchModal({ strings }) {
    const [sendNotifications, setSendNotifications] = useBooleanState(true);
    const [name, setName] = useState("");
    const [searchData, setSearchData] = useState();
    function handleEvent(data) {
        setSearchData(data);
    }
    async function save() {
        if (!name || !searchData)
            return;
        const data = {
            name,
            queryString: location.search.replace("?", ""),
            source: searchData.source,
            resultIds: searchData.resultIds,
            sendNotifications,
        };
        await usersApiClient.saveSearch(data);
        setSearchData(undefined);
    }
    useEffect(() => {
        var _a;
        const sub = events.onShowSaveSearch.subscribe(handleEvent);
        const queryString = new URLSearchParams(location.search);
        setName((_a = queryString.get("q")) !== null && _a !== void 0 ? _a : "");
        return () => sub.unSubscribe();
    }, []);
    return (React.createElement(Modal, { isOpen: !!searchData, title: strings.title, okBtnLabel: strings.saveBtnLabel, cancelBtnLabel: strings.cancelBtnLabel, onClose: () => setSearchData(undefined), onOk: save },
        React.createElement("div", { className: styles.content },
            React.createElement("input", { type: "text", placeholder: strings.namePlaceholder, value: name, onChange: (e) => setName(e.target.value) }),
            React.createElement(Checkbox, { checked: sendNotifications, setChecked: setSendNotifications, label: strings.yesSendMeNotificationsLabel, className: styles.checkbox }),
            React.createElement("span", { className: styles.notificationInfo }, strings.notificationsInfo))));
}
